// 获取检测区间项默认值
export const getRangeDefault = () => ({
  code: 'temp',
  type: 0,
  min: 2,
  max: 8
})

// 获取通过占比默认值
export const getProportionDefault = () => ({
  type: 3,
  color: '#00ff00',
  val: 85
})
